import { Card } from '@digdir/designsystemet-react';

import styled from '../../../../../../styled';

const FormContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-6);
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: var(--ds-size-4);
`;

const StyledCard = styled(Card)`
  border-radius: var(--ds-border-radius-md);
`;

export { FormContentWrapper, FieldGroup, ButtonWrapper, StyledCard };
